import React from "react";
import ReactDOM from 'react-dom';

export default class Modal extends React.Component {

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.visible !== this.props.visible) {
			if (this.props.visible) {
				document.body.style.overflowY = "hidden"
			} else {
				if (document.querySelectorAll(".customModalMask").length === 0) {
					document.body.style.overflowY = "unset"
				}
			}
		}
	}
	render() {
		const {
			visible = false,
			setVisible = () => { },
			footer = true,
			header = true,
			className = "",
			title = "",
			cancelText = "Cancel",
			okText = "OK",
			onlyOkBtn = false,
			onOk = () => { },
			onCancel = () => { },
			disabled = false,
			fullscreen,
			isColumn = false,
			children
		} = this.props;
		return (
			visible ? (
				ReactDOM.createPortal((
					<div className={`depositModalMask customModalMask ${className}`}>
						<div className={`modalCotent ${fullscreen ? "fullscreen" : ""} customModalCotent`}>
							{header && (
								<div className={`modalTitle customModalTitle`}>{title}</div>
							)}
							<div className={`modalBody customModalBody`}>{children}</div>
							{!fullscreen && footer && (
								<>
									<div className={`modalButtonBox customModalButtonBox`}>
										{!onlyOkBtn && (
											<div ghost className='cancelBtn' onClick={onCancel}>{cancelText}</div>
										)}
										<div className={`okBtn ${disabled ? 'disabled' : ''}`} onClick={onOk} disabled={disabled}>{okText}</div>
									</div>
									{
										isColumn && onlyOkBtn && <div className={`modalButtonBox customModalButtonBox`}>
											<div ghost className='cancelBtn' onClick={onCancel}>{cancelText}</div>
									</div>
									}
								</>
							)}
						</div>
					</div>
				), document.body
				)) : (
				null
			)
		);
	}
}
